import React from "react";
import { Section } from "../ui/Section";
import { Field } from "../ui/Field";
import { MultiSelectChips } from "../ui/MultiSelectChips";
import styles from "../../styles/evento-form.module.css";
import { isDateInRange, fmtLongDate } from "../../domain/eventoUtils";

export function StepActividades({
    form,
    setNotice,

    // acciones form
    addItem,
    removeItem,
    updateArray,

    // accordion
    isActOpen,
    toggleAct,
    setOpenActs,

    // catálogos / opciones
    tiposEvento,
    personasEventoOptions,
}) {
    return (
        <Section
            title="Actividades"
            aside={
                <div className={styles["actions-row"]}>
                    <button
                        className={`${styles.btn} ${styles.primary}`}
                        type="button"
                        onClick={() => {
                            addItem("actividades", {
                                nombre: "",
                                tipo: "",
                                fecha: "",
                                participanteIds: [],
                            });
                            const newIdx = form.actividades.length;
                            setOpenActs((s) => new Set([...s, newIdx]));
                        }}
                    >
                        + Añadir
                    </button>
                </div>
            }
        >
            {form.actividades.map((a, i) => {
                const open = isActOpen(i);
                const resumen = `${a.nombre || "Sin nombre"} • ${a.tipo || "Sin tipo"} • ${fmtLongDate(a.fecha) || "Sin fecha"
                    } • ${a.participanteIds?.length || 0} persona(s)`;

                return (
                    <div
                        key={`act-${i}`}
                        className={`${styles["item-card"]} ${styles.accordion} ${open ? styles.open : ""}`}
                    >
                        <button
                            type="button"
                            className={styles["accordion-header"]}
                            onClick={() => toggleAct(i)}
                            aria-expanded={open}
                            aria-controls={`act-body-${i}`}
                        >
                            <div className={styles["accordion-title"]}>
                                <strong>Actividad {i + 1}</strong>
                                <span className={styles.muted}>— {resumen}</span>
                            </div>
                            <span className={styles.chevron} aria-hidden>
                                ▾
                            </span>
                        </button>

                        <div id={`act-body-${i}`} className={styles["accordion-body"]}>
                            <div className={styles["item-row"]}>
                                <div className={styles["grid-3"]}>
                                    <Field label="Nombre">
                                        <input
                                            className={styles.input}
                                            type="text"
                                            value={a.nombre}
                                            onChange={(e) =>
                                                updateArray("actividades", i, "nombre", e.target.value)
                                            }
                                        />
                                    </Field>

                                    <Field label="Tipo">
                                        <select
                                            value={a.tipo}
                                            onChange={(e) => updateArray("actividades", i, "tipo", e.target.value)}
                                        >
                                            <option value="">Selecciona tipo</option>
                                            {tiposEvento.map((t) => (
                                                <option key={t.codigo} value={t.codigo}>
                                                    {t.descripcion}
                                                </option>
                                            ))}
                                        </select>
                                    </Field>

                                    <Field label="Fecha">
                                        <input
                                            type="date"
                                            value={a.fecha}
                                            min={form.fechaInicio || undefined}
                                            max={form.fechaFin || undefined}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (!isDateInRange(val, form.fechaInicio, form.fechaFin)) {
                                                    setNotice(
                                                        "La fecha de la actividad debe estar entre la fecha de inicio y fin del evento."
                                                    );
                                                    return;
                                                }
                                                setNotice("");
                                                updateArray("actividades", i, "fecha", e.target.value);
                                            }}
                                        />
                                    </Field>
                                </div>

                                <Field label="Participantes (solo los del evento)">
                                    <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                                        <button
                                            type="button"
                                            className={`${styles.btn} ${styles.ghost}`}
                                            onClick={() =>
                                                updateArray(
                                                    "actividades",
                                                    i,
                                                    "participanteIds",
                                                    personasEventoOptions.map((p) => p.value)
                                                )
                                            }
                                        >
                                            Añadir todos
                                        </button>

                                        <button
                                            type="button"
                                            className={`${styles.btn} ${styles.ghost}`}
                                            onClick={() => updateArray("actividades", i, "participanteIds", [])}
                                        >
                                            Quitar todos
                                        </button>
                                    </div>

                                    <MultiSelectChips
                                        options={personasEventoOptions}
                                        value={a.participanteIds || []}
                                        onChange={(vals) => updateArray("actividades", i, "participanteIds", vals)}
                                        placeholder="Buscar participante…"
                                    />
                                </Field>

                                <div className={styles["item-actions"]}>
                                    <button
                                        className={`${styles.btn} ${styles.danger}`}
                                        type="button"
                                        onClick={() => removeItem("actividades", i)}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </Section>
    );
}
